module.exports = __webpack_public_path__ + "img/aleman.151f211d.svg";